import BannerAlert, { BannerProps } from "@/components/wpl/banner-alert/src";
import {
    ProductNavBar,
    ProductNavBarProps
} from "@/components/wpl/product-navbar/src";
import { cssReset } from "@/libraries/wpl/foundations/src";
import GlobalFooter from "@/patterns/global-footer/src/index";
import PaidHero, { PaidHeroProps } from "@/patterns/paid-hero";
import PaidCtaPrimary from "@/patterns/paid-landings/paid-cta-primary";
import PaidSocialProof, {
    PaidSocialProofProps
} from "@/patterns/paid-landings/paid-social-proof";
import PaidTabs, { PaidTabsProps } from "@/patterns/paid-landings/paid-tabs";
import ThreeAlternatingImageText, {
    PatternThreeAlternatingImageTextProps
} from "@/patterns/three-alternating-image-text/src/three-alternating-image-text";
import { PatternCTAMobileProps } from "@/patterns/wpl/cta-primary/src";

interface HeroProps extends PaidHeroProps {
    styles: object;
}
interface CtaProps extends PatternCTAMobileProps {
    styles: object;
}
interface TabsProps extends PaidTabsProps {
    styles: object;
}

export interface PaidLandingProps {
    productNavProps: ProductNavBarProps;
    bannerAlertProps?: BannerProps;
    heroProps: HeroProps;
    tabsProps: TabsProps;
    alternatingTextAndImageProps: PatternThreeAlternatingImageTextProps;
    ctaProps: CtaProps;
    testimonialProps: PaidSocialProofProps;
}

export const PaidLandingTemplate = ({
    productNavProps,
    bannerAlertProps,
    heroProps,
    tabsProps,
    ctaProps,
    alternatingTextAndImageProps,
    testimonialProps
}: PaidLandingProps) => {
    const { styles: heroStyles, ...otherHeroProps } = heroProps;
    const { styles: ctaStyles, ...otherCtaProps } = ctaProps;
    const { styles: tabsStyles, ...otherTabsProps } = tabsProps;

    return (
        <div css={cssReset}>
            <ProductNavBar {...productNavProps} />
            {bannerAlertProps && <BannerAlert {...bannerAlertProps} />}
            <section id="start-trial" css={heroStyles}>
                <PaidHero {...otherHeroProps} />
            </section>
            <div style={tabsStyles}>
                <PaidTabs {...otherTabsProps} />
            </div>
            <ThreeAlternatingImageText {...alternatingTextAndImageProps} />
            <div css={ctaStyles}>
                <PaidCtaPrimary {...otherCtaProps} />
            </div>
            <PaidSocialProof {...testimonialProps} />
            <GlobalFooter />
        </div>
    );
};
